import { transform } from "node-json-transform";
import store from "@/store";
import { getPinyin } from "@/utils/pinyin";

export function buildOfflineUniqueId(showPhone, participantId, partyId) {
  partyId = partyId ?? "";
  participantId = parseInt(participantId);
  const id =
    showPhone +
    (participantId === 0 || isNaN(participantId)
      ? "-" + partyId
      : ":" + participantId);

  return id;
}

export function buildConfMon(data) {
  const map = {
    item: {
      billingCode: "billingCode", // 会议bc
      customerCode: "customerCode", // 客户编码
      name: "confName", // 会议名称
      beginTime: "confBeginTime", // 会议开始时间
      createTime: "createTime", // 会议开始时间
      endTime: "confEndTime", // 会议结束时间
      duration: "confDuration", // 会议时长 分钟
      bridgeName: "bridgeName", // 平台归属，summit几？
      recordStatus: "recordStatus", // 会议录音状态 0:未录音 1:正在录音 2:录音暂停
      muteStatus: "muteStatus", // 0:会议未全体静音1:会议已全体静音
      lockStatus: "lockStatus", // 会议锁定状态 0 会议未锁定 1 会议已锁定
      guestMuteOverride: "guestMuteOverride", // 当前会议静音状态 1：允许参会人自己解除；0:仅主持人可解除
      dialoutAllowedStatus: "dialoutAllowedStatus", // 禁止呼叫
      firstJoinTime: "firstJoinTime",
      recordValid: "recordValid", // 禁止录音
      chairmanPassword: "chairmanPassword", // 主持人密码
      partyPassword: "partyPassword", // 参与人密码
      encryptTel: "encryptTel", // 是否加密电话
      partyList: "partyList",
      qaStatus: "qaStatus",
      parties: "parties", // 会议最大允许添加人数
      waitingLineStatus: "waitingLineStatus", // 背景音状态 0: 插播线路未开启；1：正在连接插播线路；2:插播线路已开启
      status: "status", // 会议状态(0:未召开：1会议正在召开：2:会议已结束；3：会议已删除；）
      result: "result"
    },
    operate: [
      {
        run: function(ary) {
          return transform(ary, partyListMap);
        },
        on: "partyList"
      }
    ]
  };
  const partyListMap = {
    item: {
      id: "partyId",
      company: "company",
      companyLetters: "company",
      department: "department",
      departmentLetters: "department",
      phone: "phone", // 参与人电话
      name: "name", // 参与人姓名
      nameLetters: "name",
      contactId: "contactId", // 百应参会人通讯录id
      participantId: "participantId", // 编辑时使用的id
      countryCode: "countryCode", // 参与人国家码
      areaCode: "areaCode", // 参与人区号
      status: "status", // 入会状态（0 在线 1不在线2连接中4静音）
      role: "role", // 参与人角色，0：参与人，1：主持人
      showPhone: "showPhone", // 完整的参与人电话，用于列表显示，格式为（国码）+区号+电话
      city: "city",
      pin: "pin", // pin码
      connectTime: "joinTime",
      disconnectReason: "disconnectReason",
      uniqueId: ["showPhone", "participantId", "partyId"]
    },
    operate: [
      {
        run: function(ary) {
          return buildOfflineUniqueId(ary[0], ary[1], ary[2]);
          // const participantId = ary[1];
          // const partyId = ary[2] ?? "";

          // return (
          //   ary[0] + (participantId === 0 ? "-" + partyId : ":" + participantId)
          // );
        },
        on: "uniqueId"
      },
      {
        run: function(ary) {
          return transform(ary, partyListMap);
        },
        on: "partyList"
      },
      {
        run: function(ary) {
          return getPinyin(ary);
        },
        on: "nameLetters"
      },
      {
        run: function(ary) {
          return getPinyin(ary);
        },
        on: "companyLetters"
      },
      {
        run: function(ary) {
          return getPinyin(ary);
        },
        on: "departmentLetters"
      }
    ]
  };
  return transform(data, map);
}

// export function buildGroupList(data) {

// }

export function wsDataBuildParty(wsData) {
  const map = {
    item: {
      id: "partyId",
      phone: "phone", // 参与人电话
      name: "name", // 参与人姓名
      nameLetters: "name",
      city: "city",
      company: "company",
      companyLetters: "company",
      department: "department",
      departmentLetters: "department",
      connectTime: "connectTime",
      countryCode: "country", // 参与人国家码
      contactId: "contactId", // 百应参会人通讯录id
      participantId: "participantId", // 编辑时使用的id
      areaCode: "areaCode", // 参与人区号
      status: "partyStatus", // 入会状态（0 在线 1不在线2连接中4静音）
      role: "role", // 参与人角色，0：参与人，1：主持人
      pin: "pin",
      disconnectReason: "disconnectReason",
      showPhone: "acmPhone", // 完整的参与人电话，用于列表显示，格式为（国码）+区号+电话
      uniqueId: ["acmPhone", "participantId", "partyId"],
      error: ["participantId"]
    },
    operate: [
      {
        run: function(ary) {
          return buildOfflineUniqueId(ary[0], ary[1], ary[2]);
          // const participantId = ary[1];
          // const partyId = ary[2] ?? "";

          // return (
          //   ary[0] + (participantId === 0 ? "-" + partyId : ":" + participantId)
          // );
        },
        on: "uniqueId"
      },
      {
        run: function(ary) {
          // participantId为0时数据异常
          return parseInt(ary[0]) === 0;
        },
        on: "error"
      },
      {
        run: function(ary) {
          if (undefined === ary || null === ary || "" === ary) {
            throw new Error("empty acmPhone");
          }
          return ary;
        },
        on: "showPhone"
      },
      {
        run: function(ary) {
          return ary === undefined || ary === null ? "" : ary;
        },
        on: "areaCode"
      },
      {
        run: function(ary) {
          return parseInt(ary);
        },
        on: "status"
      },
      {
        run: function(ary) {
          return parseInt(ary);
        },
        on: "role"
      },
      {
        run: function(ary) {
          return parseInt(ary);
        },
        on: "contactId"
      },
      {
        run: function(ary) {
          return typeof ary === "number" || !isNaN(parseInt(ary))
            ? parseInt(ary)
            : 0;
        },
        on: "disconnectReason"
      },
      {
        run: function(ary) {
          return parseInt(ary);
        },
        on: "participantId"
      },
      {
        run: function(ary) {
          return getPinyin(ary);
        },
        on: "nameLetters"
      },
      {
        run: function(ary) {
          return getPinyin(ary);
        },
        on: "companyLetters"
      },
      {
        run: function(ary) {
          return getPinyin(ary);
        },
        on: "departmentLetters"
      }
    ]
  };

  return transform(wsData, map);
}

const MEETING_STATUS_NOT_HELD = 0; // 会议未召开
const MEETING_STATUS_BEING_HELD = 1; // 会议正在召开
const MEETING_STATUS_END = 2; // 会议已结束
const MEETING_STATUS_DELETE = 3; // 会议已删除
const MEETING_STATUS_CANCEL = -1; // 会议已取消
const MEETING_STATUS_UN_START = -2; // 会议未开始

const MEETING_MUTE_DISABLE = 0; // 会议静音未启用
const MEETING_MUTE_ENABLE = 1; // 会议静音启用

const MEETING_RECORD_OFF = 0; // 会议未录音
const MEETING_RECORD_ON = 1; // 会议正在录音
const MEETING_RECORD_START = 1000; // 会议正在开启录音
const MEETING_RECORD_PAUSE = 2; //会议录音暂停

const MEETING_LOCK_DISABLE = 0; // 会议未锁定
const MEETING_LOCK_ENABLE = 1; // 会议锁定

const MEETING_QA_ENABLE = 1; // 问答开启
const MEETING_QA_DISABLED = 0; // 问答关闭

const MEETING_WAIT_LINE_ENABLE = 2; // 播放等待音
const MEETING_WAIT_LINE_DISABLE = 0; // 停止等待音
const MEETING_WAIT_LINE_CONNECT = 1; // 正在连接等待音

const GUEST_MUTE_OVERRIDE_ENABLE = 1;
const GUEST_MUTE_OVERRIDE_DISABLE = 0;

const DIALOUT_ALLOWED_STATUS_DISABLE = 0;
const DIALOUT_ALLOWED_STATUS_ENABLE = 1;
const DIALOUT_ALLOWED_8_STATUS_ENABLE = 2;

const RECORD_VALID_STATUS_DISABLE = 0;
const RECORD_VALID_STATUS_ENABLE = 1;

const DISCONNECT_REASON_NO = 0;
const DISCONNECT_REASON_HANGUP = 2;
const DISCONNECT_REASON_NOANSWER = 3;
const DISCONNECT_REASON_CHAIRMANHANGUP = 1;
const DISCONNECT_REASON_NOCONNECTION = 4;

const DISCONNECT_REASON_OBJECT = {
  [DISCONNECT_REASON_NO]: true,
  [DISCONNECT_REASON_HANGUP]: true,
  [DISCONNECT_REASON_NOANSWER]: true,
  [DISCONNECT_REASON_CHAIRMANHANGUP]: true,
  [DISCONNECT_REASON_NOCONNECTION]: true
};

export function disconnectReasonNo(disconnectReason) {
  return DISCONNECT_REASON_NO === disconnectReason;
}

export function disconnectReasonHangup(disconnectReason) {
  return DISCONNECT_REASON_HANGUP === disconnectReason;
}

export function disconnectReasonNoanswer(disconnectReason) {
  return DISCONNECT_REASON_NOANSWER === disconnectReason;
}

export function disconnectReasonChairmanHangup(disconnectReason) {
  return DISCONNECT_REASON_CHAIRMANHANGUP === disconnectReason;
}

export function disconnectReasonNoconnection(disconnectReason) {
  return DISCONNECT_REASON_NOCONNECTION === disconnectReason;
}

export function disconnectReasonOther(disconnectReason) {
  return !DISCONNECT_REASON_OBJECT[disconnectReason];
}

export function recordValidDisable(status) {
  return RECORD_VALID_STATUS_DISABLE === status;
}

export function recordValidEnable(status) {
  return RECORD_VALID_STATUS_ENABLE === status;
}

export function dialoutAllowedDisable(status) {
  return DIALOUT_ALLOWED_STATUS_DISABLE === status;
}

export function dialoutAllowedEnable(status) {
  return DIALOUT_ALLOWED_STATUS_ENABLE === status;
}

export function dialoutAllowed8Enable(status) {
  return DIALOUT_ALLOWED_8_STATUS_ENABLE === status;
}

export function meetingIsNotHeld(status) {
  return MEETING_STATUS_NOT_HELD === status;
}

export function meetingIsBeingHeld(status) {
  return MEETING_STATUS_BEING_HELD === status;
}

export function meetingIsQaEnable(status) {
  return MEETING_QA_ENABLE === status;
}

export function meetingIsGuestMuteOverrideEnable(status) {
  return GUEST_MUTE_OVERRIDE_ENABLE === status;
}

export function meetingIsEnd(status) {
  return MEETING_STATUS_END === status;
}

export function meetingIsDelete(status) {
  return MEETING_STATUS_DELETE === status;
}

export function meetingIsCancel(status) {
  return MEETING_STATUS_CANCEL === status;
}

export function meetingIsUnStart(status) {
  return MEETING_STATUS_UN_START === status;
}

export function getMeetingBeingHeld() {
  return MEETING_STATUS_BEING_HELD;
}

export function getMeetingEnd() {
  return MEETING_STATUS_END;
}

export function getMeetingMuteEnable() {
  return MEETING_MUTE_ENABLE;
}

export function getMeetingMuteDisable() {
  return MEETING_MUTE_DISABLE;
}

export function getMeetingWaitLineEnable() {
  return MEETING_WAIT_LINE_ENABLE;
}

export function getMeetingWaitLineConnect() {
  return MEETING_WAIT_LINE_CONNECT;
}

export function getMeetingWaitLineDisable() {
  return MEETING_WAIT_LINE_DISABLE;
}

export function getMeetingOnRecord() {
  return MEETING_RECORD_ON;
}

export function getMeetingRecordStart() {
  return MEETING_RECORD_START;
}

export function getMeetingOffRecord() {
  return MEETING_RECORD_OFF;
}

export function getMeetingPauseRecord() {
  return MEETING_RECORD_PAUSE;
}

export function getMeetingLockEnable() {
  return MEETING_LOCK_ENABLE;
}

export function getMeetingLockDisable() {
  return MEETING_LOCK_DISABLE;
}

export function getMeetingGuestMuteOverrideEnable() {
  return GUEST_MUTE_OVERRIDE_ENABLE;
}

export function getMeetingGuestMuteOverrideDisable() {
  return GUEST_MUTE_OVERRIDE_DISABLE;
}

export function getMeetingQaEnable() {
  return MEETING_QA_ENABLE;
}

export function getMeetingQaDisable() {
  return MEETING_QA_DISABLED;
}

// const MEETING_STATUS_NOT_START = 0; // 0：未召开
// const MEETING_STATUS_START = 1; // 1：正在召开
// const MEETING_STATUS_END = 2; // 2：已结束
// const MEETING_STATUS_DELETE = 4; // 2：已删除

// const CUST_ROLE_CHAIRMAN = 1; // 主持人角色类型
// const CUST_ROLE_GUEST = 0; // 参会人角色类型

const CUST_STATUS_DISCONNECT = 0; // 参会断开
const CUST_STATUS_DISCONNECTING = 1; // 参会人正在断开
const CUST_STATUS_CONNECTING = 2; // 参会人连接中
const CUST_STATUS_HOLD = 3; // 会中Hold
const CUST_STATUS_MUTE = 4; // 参会人静音
const CUST_STATUS_LISTEN_TALK = 5; // 可听可讲
const CUST_STATUS_LISTEN_MUSIC = 100; // 听音乐
const CUST_STATUS_SERVICE = 101; // 服务中
const CUST_STATUS_OUT = 102; // 外呼走廊中，包括*8和Op外呼
const CUST_STATUS_KEEP = 103; // 通话保持

// const custOnLineStatusList = [
//   CUST_STATUS_HOLD,
//   CUST_STATUS_MUTE,
//   CUST_STATUS_LISTEN_TALK,
//   CUST_STATUS_LISTEN_MUSIC,
//   CUST_STATUS_SERVICE,
//   CUST_STATUS_KEEP
// ];

const custOnLineStatusList = {
  [CUST_STATUS_HOLD]: true,
  [CUST_STATUS_MUTE]: true,
  [CUST_STATUS_LISTEN_TALK]: true,
  [CUST_STATUS_LISTEN_MUSIC]: true,
  [CUST_STATUS_SERVICE]: true,
  // [CUST_STATUS_OUT]: true,
  [CUST_STATUS_KEEP]: true
};

const custHoldStatusList = {
  [CUST_STATUS_HOLD]: true,
  [CUST_STATUS_LISTEN_MUSIC]: true,
  [CUST_STATUS_SERVICE]: true,
  // [CUST_STATUS_OUT]: true,
  [CUST_STATUS_KEEP]: true
};

const CUST_ROLE_CHAIRMAN = 1; // 主持人
// const CUST_ROLE_NORMAL = 0; // 参与者

export function custIsChairman(role) {
  return role === CUST_ROLE_CHAIRMAN;
}

export function meetingMute(muteStatus) {
  return muteStatus === MEETING_MUTE_ENABLE;
}

export function meetingUnMute(muteStatus) {
  return muteStatus === MEETING_MUTE_DISABLE;
}

export function meetingWaitLineEnable(waitLineStatus) {
  return MEETING_WAIT_LINE_ENABLE === waitLineStatus;
}

export function meetingWaitLineDisable(waitLineStatus) {
  return MEETING_WAIT_LINE_DISABLE === waitLineStatus;
}

export function meetingWaitLineConnect(waitLineStatus) {
  return MEETING_WAIT_LINE_CONNECT === waitLineStatus;
}

export function meetingOnRecord(recordStatus) {
  return recordStatus === MEETING_RECORD_ON;
}

export function meetingRecordStart(recordStatus) {
  return recordStatus === MEETING_RECORD_START;
}

export function meetingNotRecord(recordStatus) {
  return (
    recordStatus === MEETING_RECORD_OFF || recordStatus === MEETING_RECORD_PAUSE
  );
}

export function meetingLock(lockStatus) {
  return lockStatus === MEETING_LOCK_ENABLE;
}

export function meetingUnLock(lockStatus) {
  return lockStatus === MEETING_LOCK_DISABLE;
}

export function custInParty(status) {
  return true === custOnLineStatusList[status];
}

export function custNotInParty(status) {
  return (
    status === CUST_STATUS_DISCONNECT ||
    status === CUST_STATUS_DISCONNECTING ||
    status === CUST_STATUS_CONNECTING ||
    status === CUST_STATUS_OUT
  );
}

export function custOffLine(status) {
  return (
    status === CUST_STATUS_DISCONNECT || status === CUST_STATUS_DISCONNECTING
  );
}

export function custConnecting(status) {
  return CUST_STATUS_CONNECTING === status || CUST_STATUS_OUT === status; // 添加102状态
}

export function custOnLine(status) {
  return true === custOnLineStatusList[status];
  // return status === CUST_STATUS_ONLINE || status === CUST_STATUS_MUTE;
}

export function custMute(status) {
  return status === CUST_STATUS_MUTE;
}

export function custIsHold(status) {
  return custHoldStatusList[status] ? true : false;
}

// export function getPartyStatusOnLine() {
//   return CUST_STATUS_ONLINE;
// }

export function getPartyStatusOffLine() {
  return CUST_STATUS_DISCONNECTING;
}

export function enableRecordStatus(status) {
 return CUST_STATUS_MUTE === status || CUST_STATUS_LISTEN_TALK === status;
}

// export function getPartyStatusConnecting() {
//   return CUST_STATUS_CONNECTING;
// }

// export function getPartyStatusMute() {
//   return CUST_STATUS_MUTE;
// }

const CONF_PRODUCTION_NEWPHONE = "np";
const CONF_PRODUCTION_BAIYING = "by";
const CONF_PRODUCTION_ZHIHUI = "zh";

export function isNpConf(production) {
  return CONF_PRODUCTION_NEWPHONE === production;
}

export function isByConf(production) {
  return CONF_PRODUCTION_BAIYING === production;
}

export function isZhConf(production) {
  return CONF_PRODUCTION_ZHIHUI === production;
}

export function custIsParty(role) {
  // 角色是参会人
  return BAIYING_ROLE_PARTY_ID === role;
}

const BAIYING_ROLE_CHAIRMAN_ID = 0; // 主持人
const BAIYING_ROLE_CHAIRMAN_NAME = "主持人"; // 主持人
const BAIYING_ROLE_PRESENTER_ID = 1; // 主讲人
const BAIYING_ROLE_PRESENTER_NAME = "主讲人"; // 主讲人
const BAIYING_ROLE_GUEST_ID = 3; // 嘉宾
const BAIYING_ROLE_GUEST_NAME = "嘉宾"; // 嘉宾
const BAIYING_ROLE_PARTY_ID = 2; // 参会人
const BAIYING_ROLE_PARTY_NAME = "参会人"; // 参会人

export const CONF_BAIYING_ROLE_LIST = [
  {
    id: BAIYING_ROLE_CHAIRMAN_ID,
    name: BAIYING_ROLE_CHAIRMAN_NAME
  },
  {
    id: BAIYING_ROLE_PRESENTER_ID,
    name: BAIYING_ROLE_PRESENTER_NAME
  },
  {
    id: BAIYING_ROLE_GUEST_ID,
    name: BAIYING_ROLE_GUEST_NAME
  },
  {
    id: BAIYING_ROLE_PARTY_ID,
    name: BAIYING_ROLE_PARTY_NAME
  }
];

export const CONF_BAIYING_ROLE_ID_OBJECT = {
  [BAIYING_ROLE_CHAIRMAN_ID]: BAIYING_ROLE_CHAIRMAN_NAME,
  [BAIYING_ROLE_PRESENTER_ID]: BAIYING_ROLE_PRESENTER_NAME,
  [BAIYING_ROLE_GUEST_ID]: BAIYING_ROLE_GUEST_NAME,
  [BAIYING_ROLE_PARTY_ID]: BAIYING_ROLE_PARTY_NAME
};

export function getRoleList() {
  // console.log("store.state", store.state);
  if (store.state.auth.prod == "zh") {
    return CONF_BAIYING_ROLE_LIST.filter(i => i.id != 3);
  } else {
    return CONF_BAIYING_ROLE_LIST;
  }
}
